module.exports = __webpack_public_path__ + "static/img/case_detail_17_2.d96f433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_17_2.png
// module id = 6i+3
// module chunks = 34